<template>
    <section class="app-main">

        <div class="top-bar">
            <el-input placeholder="输入邮箱或者手机号" v-model="value" @change="search" style="width:200px;margin-right:15px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <!-- <el-date-picker
                v-model="fixDate"
                @change="handleDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 360px; margin-right: 15px"
            ></el-date-picker> -->
            <el-button  class="top-btn" type="success" plain @click="handleBatch(1)">群发短信</el-button>
            <el-button  type="primary" plain @click="handelReset">重置发送用户</el-button>
        </div>
        <el-card shadow="hover">
            <el-table :data="tableData" @selection-change="handleChecked" empty-text="暂无用户" height="560">
                <el-table-column type="selection"  width="100"     align="center"> </el-table-column>
                <!-- <el-table-column prop="nickname"   label="昵称"    align="center"></el-table-column> -->
                <el-table-column prop="realname"   label="姓名"    align="center">
                    <template slot-scope="scope"> 
                        {{ scope.row.first_name + " " +  scope.row.last_name }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="sex_title"  label="性别"    align="center"> </el-table-column> -->
                <el-table-column prop="phone"      label="手机号"  align="center"> </el-table-column>
                <el-table-column prop="email"      label="邮箱"    align="center"> </el-table-column>
                <!-- <el-table-column prop="created_at"      label="注册时间"    align="center"> </el-table-column> -->
                <el-table-column prop="is_msg"      label="发送状态"    align="center"> 
                    <template slot-scope="scope"> 
                        <span v-if="scope.row.is_msg">
                            已发送
                        </span>
                        <span v-else>
                            未发送
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        

    </section>
</template>


<script>
import { member_activity_list,member_send_activity_msg,member_reset_msg } from '@/api/platform.js'

export default {
    name: "UserList",
    data() {
        return {
            fixDate: [],
            value: '',
            tableData: [],
            page:1,
            size:20,
            total:0,
            dialog:false,    // 控制显示 添加修改弹窗
            ids:[],          // table 选中数据的 id 数组集合
        }
    },
    methods: {
        // 日期查询搜索
        handleDate() {
            this.page = 1;
            this.handleData()
        },
        // 搜索会员
        search() {
            this.page = 1;
            this.handleData()
        },
        // 获取会员数据
        handleData(){
            let params = {
                page:this.page
            }
            if(this.value != "") {
                params.search = this.value
            }
            if (this.fixDate && this.fixDate.length != 0) {
                params.start_date_search = this.fixDate[0];
                params.end_date_search = this.fixDate[1];
            }
            member_activity_list(2,params).then(res => {
                //  console.log(res.data)
                if(res.code == 20000){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }
            }).catch(err => {
                console.log(err)
                this.tableData = []
            })
        },
        reloadData(page){
            this.page = page
            this.handleData()
        },
        // 监听 table 选中事件，获取选中数据的id 
        handleChecked(rows){
            rows.forEach(e => {
                this.ids.push(e.role_id)
            })
        },
        // 群发邮件
        handleBatch(){
         member_send_activity_msg(2).then(res => {  
                if(res){
                    this.$message({type:'success',message:res.msg})
                    this.page = 1;
                    this.handleData()
                }
            })
        },
        // 重置用户发送
        handelReset() {
            this.$confirm(`此操作将重置已发送用户，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                member_reset_msg(2).then(res => {
                    if(res) {
                        this.$message({type:'success',message:res.msg})
                        this.handleData();
                    }
                })
            }).catch(() => {})
        }
    },
    created(){
        this.handleData();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 100px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>